import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import CarBranding from "../pages/carBranding/CarBranding";
import Billboard from "../pages/billboard/Billboard";
import CustomMaterials from "../pages/customMaterials/CustomMaterials";
import Branding3D from "../pages/branding3D/Branding3D";
import Contact from "../pages/contact/Contact";

const RouteConfig = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/car-branding" element={<CarBranding />} />
      <Route path="/billboard" element={<Billboard />} />
      <Route path="/custom-materials" element={<CustomMaterials />} />
      <Route path="/3d-branding" element={<Branding3D />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
};

export default RouteConfig;
